export { SESSION_STATUS } from '@or-sdk/hitl';
export * from './agents';
export * from './common';
export * from './session-events';
export * from './layout';

export const LOCAL_STORAGE_KEYS = {
  AGENT_UI_SETTINGS: 'HITL-Agent-UI-Settings',
  SESSION_VIEWS: 'HITL-Session-Views',
  EVENT_TEMPLATES: 'HITL-Event-Templates',
  ACW_SETTINGS: 'HITL-ACW-settings',
  /** TODO: Delete when workspace settings store is updated */
  LAYOUT: 'HITL_LOCAL_SETTINGS',
};
